'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';

export class StorageSelectComponent {

  Storage;
  storages;
  categoryId;
  allowAddon;
  title;
  ngRequired;
  ngModel;

  constructor(Storage) {
    'ngInject';

    this.Storage = Storage;
  }

  $onInit() {
    this.storages = this.Storage.getStorages();
  }

  onAdd(storage){
    this.ngModel = storage._id;
  }

  clear() {
    this.ngModel = undefined;
  }
}

export default angular.module('ascuteApp.form.element.storage', [uiBootstrap])
  .component('storageSelect', {
    bindings: {
      ngModel: '=', 
      ngRequired: '=',
      title: '=',
      allowAddon: '=',
      categoryId: '=',
      raw: '=',
      noStyle: '='
    },
    template: require('./select.html'),
    controller: StorageSelectComponent,
    transclude: true
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/form/element/storage/select.js